<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="chevron-down-small">
<path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M6.3796 10.1467C6.57486 9.95143 6.89145 9.95143 7.08671 10.1467L12.3998 15.4598L17.7129 10.1467C17.9082 9.95143 18.2248 9.95143 18.42 10.1467C18.6153 10.342 18.6153 10.6585 18.42 10.8538L12.7534 16.5205C12.5581 16.7157 12.2415 16.7157 12.0463 16.5205L6.3796 10.8538C6.18434 10.6585 6.18434 10.342 6.3796 10.1467Z" fill="#212328"/>
</g>
</svg>
